module.exports = __webpack_public_path__ + "img/account-protection.ef9b59bf.png";